import { chakra, EloCardSecondary } from '@plurall/elo-v3';

import {
  strategicInsightsHeaderRecipe,
  strategicInsightsHeadingRecipe,
  strategicInsightsIconRecipe,
  strategicInsightsInsightRecipe,
  strategicInsightsItemCardRecipe,
  strategicInsightsItemRecipe,
  strategicInsightsLabelRecipe,
  strategicInsightsListRecipe,
  strategicInsightsRecommendationLabelRecipe,
  strategicInsightsRecommendationHeaderRecipe,
  strategicInsightsRecommendationRecipe,
  strategicInsightsRecommendationTextRecipe,
  strategicInsightsTitleRecipe,
} from './StrategicInsightsCard.recipe';

export const StrategicInsightsListFactory = chakra('div', strategicInsightsListRecipe);
export const StrategicInsightsItemCardFactory = chakra(EloCardSecondary.Root, strategicInsightsItemCardRecipe);
export const StrategicInsightsItemFactory = chakra('article', strategicInsightsItemRecipe);
export const StrategicInsightsHeaderFactory = chakra('div', strategicInsightsHeaderRecipe);
export const StrategicInsightsIconFactory = chakra('span', strategicInsightsIconRecipe);
export const StrategicInsightsHeadingFactory = chakra('div', strategicInsightsHeadingRecipe);
export const StrategicInsightsLabelFactory = chakra('p', strategicInsightsLabelRecipe);
export const StrategicInsightsTitleFactory = chakra('h3', strategicInsightsTitleRecipe);
export const StrategicInsightsInsightFactory = chakra('p', strategicInsightsInsightRecipe);
export const StrategicInsightsRecommendationFactory = chakra('div', strategicInsightsRecommendationRecipe);
export const StrategicInsightsRecommendationHeaderFactory = chakra('div', strategicInsightsRecommendationHeaderRecipe);
export const StrategicInsightsRecommendationLabelFactory = chakra('p', strategicInsightsRecommendationLabelRecipe);
export const StrategicInsightsRecommendationTextFactory = chakra('p', strategicInsightsRecommendationTextRecipe);
